import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'COUNTRY_UPDATE',
    smsDelete : 'COUNTRY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        country: [],

        submitSuccess: false,
        countryLoading: false,
        countryError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_COUNTRY(state, country) {
            state.country = country;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        COUNTRY_LOADING (state, loading) {
            state.countryLoading = loading;
        },

        COUNTRY_ERROR (state, hasError) {
            state.countryError = hasError;
        }
    },

    actions: {
        async addCountry ({commit, dispatch}, payload) {
            commit('COUNTRY_LOADING', true);
            commit('COUNTRY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_country, payload.country, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCountry')
                return response

            } catch (e) {
                commit('COUNTRY_ERROR', true);
            } finally {
                commit('COUNTRY_LOADING', false);
            }
        },

        async fetchCountry ({ commit }) {
            commit('COUNTRY_LOADING', true);
            commit('COUNTRY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.country_list, config);
                let response = result.data
                commit('SET_COUNTRY', response.data);

            } catch(error) {
                commit('COUNTRY_ERROR', true);
            } finally {
                commit('COUNTRY_LOADING', false);
            }
        },

        async updateCountry ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_country + payload.id, payload.country, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCountry')
                return response

            } catch (e) {
                commit('COUNTRY_ERROR', true);
            } finally {
                commit('COUNTRY_LOADING', false);
            }
        },
        
        async deleteCountry({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.country_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCountry')
            return response
        }
    },

    getters: {}
}
